import { Body } from '@assembly-js/design-system';
import React from 'react';

export const ErrorText: React.FC = ({ children }) => (
  <div className="text-red">
    <Body className="font-medium leading-6" size="sm" tag="div">
      {children}
    </Body>
  </div>
);
